import { render, staticRenderFns } from "./Types of bonuses.vue?vue&type=template&id=0a3e43d9"
import script from "./Types of bonuses.vue?vue&type=script&lang=js"
export * from "./Types of bonuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports